import Commons from '../../../../Services/Common/Common';

export const M_TBG_CUSTOM_02_Schema = {
  mapper: {
    search1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd ?? ''),
    },
    search2: {
      UserId: (context) => context.userInfo?.userid,
      TbmYn: (context) => Commons.EncryptAES(context.userInfo?.tbmYn) || '',
    },
    save1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd) || '',
      EStep: (row) => Commons.EncryptAES(String(row.eStep ?? '')) || '',
      MStep: (row) => Commons.EncryptAES(String(row.mStep ?? '')) || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
